<template>
  <div id="scroll">
    <div class="container">
      轮播图管理

      <el-button
        type="danger"
        icon="el-icon-delete"
        @click="handleDelete(deleteArr)"
        >批量删除</el-button
      >
      <el-button type="success" @click="dialogVisible2 = true"
        >上传文件</el-button
      >
      <el-table
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column prop="oldName" label="名称" width="180">
        </el-table-column>
        <el-table-column label="预览">
          <template slot-scope="scope">
            <el-image
              style="width: 1.25rem; height: 1.25rem"
              v-show="scope.row.fileUrl"
              :src="scope.row.fileUrl?
                baseURL +
                scope.row['fileUrl'] +
                scope.row['newName']:''
              "
              :preview-src-list="srcList"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageNo"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
    </div>

    <!-- 上传文件 -->
    <el-dialog
      title="上传轮播图"
      :visible.sync="dialogVisible2"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-upload
        class="upload-demo"
        :before-upload="beforeUpload"
        :http-request="upload"
        ref="upload"
        action=""
        :on-remove="removeFile"
        :on-success="uploadFile"
        multiple
      >
        <el-button size="small" type="primary">选择文件</el-button>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUpload()">取 消</el-button>
        <el-button type="primary" @click="getFileRes()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getScroll, delScrool, uploadViewPaper } from "@/api/manage"; //按需引入请求接口
import config from "@/config/url.config";
export default {
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      pageTotal:0,
      dialogVisible2: false,
       baseURL: config.baseURL,
      newFile: new FormData(),
      fileObj: {},
      deleteArr: [],
      tableData: [],
      srcList:[]
    };
  },
  created() {
    this.getScrollList()
  },
  mounted() {},
  methods: {
    async getScrollList() {
      //获取轮播图的数据
      this.tableData=[]
      this.srcList=[]
      let res = await getScroll(this.query);
      if (res.code == 250) {
      } else if (res.code == 200) {
        this.tableData=res.data
        this.srcList=[]
        this.pageTotal=+res.total
        this.tableData.map((item) => {
          let url =item.fileUrl?
            config.baseURL +
            item["fileUrl"] +
            item["newName"]:''
          this.srcList.push(url);
        });
      }
    },
    handleSelectionChange(val) {
      //多选操作,批量删除
      this.deleteArr = [];
      val.map((item) => {
        this.deleteArr.push(item.id);
      });
    },
    handleDelete(ids) {
      //删除以及批量删除
      if(ids.length==0){
      return this.$message.error('未选择删除项')
    }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let param = {};
            param.ids = Array.isArray(ids)
              ? JSON.stringify(ids)
              : JSON.stringify([ids]);
          let res = await delScrool(param);
         if(res.code=='200'){
           this.$message.success('删除成功！')
           console.log('param',param);
           if((JSON.parse(param.ids)).length==this.tableData.length){
             this.query.pageNo--
           }
           this.getScrollList()
         }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    beforeUpload(file) {
      //文件上传之前的钩子
      if (file) {
        this.newFile.append("file", file);
        let newFile = new FormData();
        newFile.append("file", file);
        this.fileObj[file.name] = newFile;
      } else {
        return false;
      }
    },
    upload() {
      //文件上传时的钩子
    },
    removeFile(file, fileList) {
      //删除文件时的钩子
      for (let k in this.fileObj) {
        if (k == file.name) {
          delete this.fileObj[k];
        }
      }
    },
    uploadFile(response, file, fileList) {
      //文件上传成功时的钩子
    },
    cancelUpload() {
      //取消上传
      this.dialogVisible2 = false;
      this.fileObj = {};
      this.isEdit = false;
      this.$refs.upload.clearFiles();
    },
    async getFileRes() {
      //确认上传图片
      let flage = null;
      if (JSON.stringify(this.fileObj) != "{}") {
        this.dialogVisible2 = false;
        for (let k in this.fileObj) {
            console.log(this.fileObj[k].get("file"));
          let res = await uploadViewPaper(this.fileObj[k]);
          this.dialogVisible2 = false;
          if (res.code == 250) {
            return this.$message.error("文件上传失败！");
          } else if (res.code == 200) {
            if (!flage) {
              this.$message({
                type: "success",
                message: "上传图片成功!",
              });
            }
            flage = 1;
          }
        }
         this.fileObj = {};
          this.$refs.upload.clearFiles(); //上传文件结束后清除列表
      } else if (JSON.stringify(this.fileObj) == "{}") {
        return this.$message.error("未选择图片！");
      }
    },
    handlePageChange(val) {
          this.$set(this.query, 'pageNo', val);
          this.getScrollList();
      },
  },
};
</script>

<style>
#scroll {
  height: 100%;
}
.container {
  padding: 30px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
}
</style>